import * as React from 'react';
import * as screen1 from "./style.module.scss";
import { HeaderLogoAndTel } from "../../../../HeaderLogoAndTel";
import { WebDate } from "../../../../WebDate";
export const Screen1 = ({ id }) => {
  return (
    <header className={screen1.screen1}>
      <div className="container">
        <HeaderLogoAndTel/>
        <div className={screen1.col}>
          <p className={screen1.time}>
            <WebDate id={id}/>
          </p>
          <p className={screen1.type}>Бесплатный вебинар</p>
          <h1>Как помочь ребёнку с обучением в начальной школе</h1>
          <p className={screen1.desc}>Вебинар для родителей детей: дошкольников, учеников начальной школы, со сложностями чтения и пониманием прочитанного</p>
          <a href="#widget" className={screen1.btn}>Зарегистрироваться</a>
          <p className={screen1.gift}>Подарок за регистрацию: список книг, которые ребенок захочет читать сам</p>
        </div>

        <div className={`${screen1.col} ${screen1.mob}`}>
          <h1 className={screen1.mob}>Как помочь ребёнку с обучением в начальной школе</h1>
          <p className={`${screen1.desc} ${screen1.mob}`}>Бесплатный вебинар для родителей детей: дошкольников, учеников начальной школы, со сложностями чтения и пониманием прочитанного</p>
          <div className={`${screen1.time} ${screen1.mob}`}>
            <img src="https://fs.advance.ru/landing-pages/webinar/kak_nauchit_rebenka_chitat/fire-icon.png" alt={""}/>
            <WebDate id={id}/>
            <img src="https://fs.advance.ru/landing-pages/webinar/kak_nauchit_rebenka_chitat/fire-icon.png" alt={""}/>
          </div>
          <a href="#widget" className={`${screen1.btn} ${screen1.mob}`}>Зарегистрироваться</a>
          <p className={screen1.gift}>Подарок за регистрацию: список книг, которые ребенок захочет читать сам</p>
        </div>
      </div>
    </header>
  );
};
